import React from 'react';
import { Settings } from 'lucide-react';

const SettingsView = () => {
  return (
    <div className="space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="flex items-center space-x-4 mb-6">
          <Settings className="w-8 h-8 text-gray-400" />
          <h2 className="text-xl font-semibold">System Settings</h2>
        </div>

        <div className="space-y-6">
          <p className="text-gray-600">
            System settings and configuration options will be available here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SettingsView;